<button (click)="protectUnprotectDatetime(true)" *ngIf="state" [disabled]="employees?.length === 0 && !employeeDatetimeId" class="btn btn-icon btn-light text-muted" title="{{ 'employees_datetimes.lock_attendance' | translate }}" type="button">
    <i class="mdi mdi-lock-outline"></i>
</button>
<button (click)="protectUnprotectDatetime(false)" *ngIf="!state" [disabled]="employees?.length === 0 && !employeeDatetimeId" class="btn btn-icon btn-light text-muted" title="{{ 'employees_datetimes.unlock_attendance' | translate }}" type="button">
    <i class="mdi mdi-lock-open-variant-outline"></i>
</button>
